<template>
  <el-form label-position="top" disabled>
    <el-form-item :label="$t('ec-line028.content.payment.paymentMethod')">
      <disabled-input :value="paymentMethodText" />
    </el-form-item>
    <div v-if="isCreditCard" class="bg-gray-450 px-4 py-4 text-black flex flex-row justify-between mt-5">
      <span class="font-bold text-base">{{ Utils.helper.formatCard(cardNumber) }}</span>
      <span class="text-base">{{ $t('common.cardExpired', { month: expiredMonth, year: expiredYear }) }}</span>
    </div>
  </el-form>
</template>

<script>
import DisabledInput from '@/components/DisabledInput.vue'

export default {
  components: { DisabledInput },
  props: {
    data: { type: Object, defautl: () => {} },
  },
  computed: {
    isCreditCard() {
      return (
        this.data.payment_methods.find((i) => i.id === this.data.payment.payment_id)?.payment_service_id ===
        this.Constants.PAYMENT_METHOD.CREDIT_CARD
      )
    },
    cardNumber() {
      return this.isCreditCard ? this.data.payment.card_no ?? this.data.payment.card_number : ''
    },
    paymentMethodText() {
      return this.data.payment_methods.find((i) => i.id === this.data.payment.payment_id)?.payment_method
    },
    expiredMonth() {
      return this.isCreditCard
        ? this.data.payment.expire
          ? this.data.payment.expire.split(/([\d]{2})/)[3]
          : this.data.payment.expiry_month
        : ''
    },
    expiredYear() {
      return this.isCreditCard
        ? this.data.payment.expire
          ? this.data.payment.expire.split(/([\d]{2})/)[1]
          : this.data.payment.expiry_year
        : ''
    },
  },
}
</script>

<style></style>
